import { AssistantMessageExtra } from "./Assistant";
import { UserMessageExtra } from "./User";
export var renderMessagesExtra = {
  assistant: AssistantMessageExtra,
  user: UserMessageExtra
};